import { ContactUs } from "@Components/contact-us/ContactUs";
import CmsPage, { getCMSPageModel } from "@Libs/contentful/components/CmsPage";
import ContactUsPageQuery from "@Libs/contentful/queries/ContactUsPage";
import { pageModel } from "@Types/Contentful";
import { IContactUsContent } from "@Types/contact-us-page";
import { makeStaticProps, getStaticPaths } from "@wff/libs/i18n/getStatic";

interface IContactUsPage {
  pageModel: pageModel;
}

const ContactUsPage = ({ pageModel }: IContactUsPage) => {
  const { pageContent = {} } = pageModel;

  return (
    <CmsPage
      pageModel={pageModel}
      pageTitle={pageContent.pageTitle ?? ""}
      pageDescription={pageContent.pageDescription ?? ""}
    >
      <ContactUs {...(pageContent as IContactUsContent)} />
    </CmsPage>
  );
};

const overrideStaticProps = async (props: any) => {
  const { locale } = props;

  const pageModel = await getCMSPageModel(ContactUsPageQuery, {
    locale,
  });

  return {
    props: {
      pageModel,
    },
  };
};

const getStaticProps = makeStaticProps(["common"], overrideStaticProps);
export { getStaticPaths, getStaticProps };

export default ContactUsPage;
